import React from 'react';
import OfferingSeverityComponent from "./OfferingSeverityComponent";
import {padCalendar} from "../../../util";

const formatOfferingSeverity = (classPeriodOfferings, offeringSeveritys) => {
	
	for (const offeringSeverity of offeringSeveritys) {
		let offeringObj = classPeriodOfferings.find(element => element.offeringId === offeringSeverity.offeringId);
		offeringSeverity.date = padCalendar(offeringObj.offeringDate);
		offeringSeverity.offeringShares = offeringObj.offeringShares;
		offeringSeverity.offeringPrice = offeringObj.offeringPrice;
		offeringSeverity.retainedShares = (offeringObj.offeringShares - offeringSeverity.soldShares);
		//offeringSeverity.soldSeverity = offeringSeverity.soldShares * (offeringObj.offeringPrice-offeringSeverity.avgSoldPrice);
		//offeringSeverity.retainedSeverity = offeringSeverity.retainedShares * offeringSeverity.priceDecline;
		//offeringSeverity.totalSeverity = offeringSeverity.soldSeverity + offeringSeverity.retainedSeverity;

	}

	return offeringSeveritys;
};

const ClassPeriodTradingStatContainer = (props) => {
	if (!props.classPeriodOfferings || !props.offeringExposures) {
		return <div>Loading</div>
	}

	const data = formatOfferingSeverity(props.classPeriodOfferings, props.offeringExposures);

	return (
		<React.Fragment>
			<OfferingSeverityComponent offeringSeveritys={data} />
		</React.Fragment>
	);

};


export default ClassPeriodTradingStatContainer;



// WEBPACK FOOTER //
// ./src/common/components/OfferingSeverity/OfferingSeverityContainer.js